// extracted by mini-css-extract-plugin
export var box = "Container-module--box--d1556";
export var box_md = "Container-module--box_md--61e96";
export var box_xmd = "Container-module--box_xmd--22060";
export var box_flex = "Container-module--box_flex--23c81";
export var box_lg = "Container-module--box_lg--375ef";
export var box_sm = "Container-module--box_sm--0e7f8";
export var box_outer = "Container-module--box_outer--7194b";
export var box_whiteBg = "Container-module--box_white-bg--0b26b";
export var box_noMarginBottom = "Container-module--box_no-margin-bottom--bc476";
export var box_noPadding = "Container-module--box_no-padding--5c475";
export var box_outerGray = "Container-module--box_outer-gray--1cca9";
export var box_dark = "Container-module--box_dark--60f06";
export var box_zIndex = "Container-module--box_z-index--3425a";
export var box_zIndex6 = "Container-module--box_z-index-6--64200";
export var box_eventsWithLine = "Container-module--box_events-with-line--1c5ec";
export var box_featuresAo = "Container-module--box_features-ao--163d7";
export var box_verticalPaddings = "Container-module--box_vertical-paddings--fc77b";
export var clearP = "Container-module--clearP--eb338";
export var clearP_vc = "Container-module--clearP_vc--59e07";
export var container = "Container-module--container--1808d";
export var paddingVertical = "Container-module--paddingVertical--d7359";
export var whiteBG = "Container-module--whiteBG--5de0f";
export var grayBG = "Container-module--grayBG--cb626";
export var blackBG = "Container-module--blackBG--c92e9";
export var transparentBG = "Container-module--transparentBG--63e4e";
export var stairs = "Container-module--stairs--2fe0c";
export var fadeInAnimation = "Container-module--fadeInAnimation--92cdc";
export var placeHolderShimmer = "Container-module--placeHolderShimmer--738d9";